import React, { useState, useRef, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

const ImageCropper = ({ imageSrc, aspect, onCropComplete, onClose }) => {
  const [crop, setCrop] = useState({ unit: "%", width: 80, aspect });
  const [completedCrop, setCompletedCrop] = useState(null);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);

  const onImageLoad = (e) => {
    imgRef.current = e.currentTarget;
  };

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) return;

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const ctx = canvas.getContext("2d");
    canvas.width = crop.width;
    canvas.height = crop.height;

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [completedCrop]);

  const handleCrop = () => {
    if (!completedCrop || !previewCanvasRef.current) return;

    previewCanvasRef.current.toBlob((blob) => {
      onCropComplete(blob);
    }, "image/jpeg");
  };

  return (
    <div>
      <ReactCrop
        src={imageSrc}
        crop={crop}
        onChange={(c) => setCrop(c)}
        onComplete={(c) => setCompletedCrop(c)}
        aspect={aspect}
      >
        <img src={imageSrc} onLoad={onImageLoad} alt="To Crop" />
      </ReactCrop>
      <canvas ref={previewCanvasRef} style={{ display: "none" }} />
      <div className="d-flex justify-content-end gap-2 mt-3">
        <button className="btn btn-secondary btn-sm" onClick={onClose}>
          Cancel
        </button>
        <button className="btn btn-success btn-sm" onClick={handleCrop}>
          Crop
        </button>
      </div>
    </div>
  );
};

export default ImageCropper;
